import {
  Box,
  ClickAwayListener,
  GKButton,
  Popover,
  SendIcon,
  UpIcon,
} from "components";
import { ModelPortfolio } from "interfaces/OrderSimulation";
import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import TradeConfirmationModal from "./TradeConfirmationModal";

const OrderSheetGeneratePopover = ({
  modelPortfolioList,
  modelId,
}: {
  modelPortfolioList: ModelPortfolio[];
  modelId: number;
}) => {
  const form = useFormContext();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [sendEmailType, setSendEmailType] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const portfolioIdsInFirstArray = new Set(
    form
      .getValues("generateTradeResponse")
      ?.map((item: { portfolioId: number }) => item?.portfolioId),
  );

  const matchedPortfolios = modelPortfolioList?.filter((item) =>
    portfolioIdsInFirstArray?.has(item.portfolioId),
  );

  return (
    <>
      <GKButton
        variant="contained"
        startIcon={<SendIcon />}
        endIcon={
          <UpIcon
            height={16}
            width={16}
            style={{
              transform: open ? "rotate(0deg)" : "rotate(180deg)",
              transition: "transform 0.3s",
              marginRight: 4,
            }}
          />
        }
        onClick={handleClick}
      >
        Save & Send
      </GKButton>

      {Boolean(anchorEl) && (
        <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
          <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            slotProps={{
              paper: { sx: { width: "149px", zIndex: 9999 } },
            }}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            transformOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <Box
              sx={{
                border: `solid 1px var(--neutral-100)`,
                borderRadius: "10px",
                boxShadow: `0px 0px 5px 4px var(--primary-50)`,
                p: "8px 0",
                bgcolor: "background.paper",
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <GKButton
                sx={{ color: "#333" }}
                onClick={() => {
                  setAnchorEl(null);
                  setSendEmailType("TRADE");
                  setConfirmationModal(true);
                }}
              >
                Send Order Sheet
              </GKButton>

              {/* <GKButton
                sx={{ color: "#333" }}
                onClick={() => {
                  setAnchorEl(null);
                  setSendEmailType("ORDER");
                  setConfirmationModal(true);
                }}
              >
                Send for Execution
              </GKButton> */}
            </Box>
          </Popover>
        </ClickAwayListener>
      )}

      {confirmationModal && (
        <TradeConfirmationModal
          open={confirmationModal}
          setOpen={setConfirmationModal}
          sendEmailType={sendEmailType}
          matchedPortfolios={matchedPortfolios}
          modelId={modelId}
        />
      )}
    </>
  );
};

export default OrderSheetGeneratePopover;
